import { Box, Card, Divider, Stack, Typography } from "@mui/material";
import { ReactNode } from "react";

interface ExportCardProps {
  id: string;
  title: string;
  description: string;
  icon: ReactNode;
  children: ReactNode;
  actions: ReactNode;
}

export function ExportCard({
  id,
  title,
  description,
  icon,
  children,
  actions,
}: ExportCardProps) {
  return (
    <Card
      component="section"
      aria-labelledby={id}
      sx={{
        p: { xs: 2, sm: 3 },
        minWidth: 0,
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Stack direction="row" spacing={2} alignItems="flex-start">
        <Box
          sx={{
            bgcolor: "action.hover",
            color: "primary.main",
            borderRadius: 2,
            p: 1.5,
            display: "flex",
            flexShrink: 0,
          }}
        >
          {icon}
        </Box>
        <Box>
          <Typography
            id={id}
            component="h2"
            variant="h6"
            fontWeight={700}
            gutterBottom
          >
            {title}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {description}
          </Typography>
        </Box>
      </Stack>
      <Divider sx={{ my: 3 }} />
      <Stack spacing={3} sx={{ flex: 1 }}>
        {children}
      </Stack>
      <Box sx={{ pt: 3, "& .MuiButton-root": { minHeight: 44 } }}>
        {actions}
      </Box>
    </Card>
  );
}
